import { render, staticRenderFns } from "./transparenciaTwo.vue?vue&type=template&id=15b74b0d"
import script from "./transparenciaTwo.vue?vue&type=script&lang=js"
export * from "./transparenciaTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports